
import { DataTable } from "@/components/ui/data-table";
import { Card, CardContent } from "@/components/ui/card";
import { getApplicationColumns } from "./ApplicationColumns";

interface ApplicationTabContentProps {
  applications: any[];
}

export const ApplicationTabContent = ({ applications }: ApplicationTabContentProps) => {
  const columns = getApplicationColumns();

  return (
    <CardContent>
      {applications.length > 0 ? (
        <DataTable columns={columns} data={applications} />
      ) : (
        <div className="text-center py-10">
          <p className="text-muted-foreground">No applications found matching your criteria</p>
        </div>
      )}
    </CardContent>
  );
};
